export default __webpack_public_path__ + "static/media/bakery_hero.cebd22cb.jpg";